export const ROTULOS_DIA_DESTACADOS_LEMBRETE = ['Hoje', 'Amanhã'];
